/* IT HIPPIE — choix de livraison dans le tiroir panier et la page panier (nov. 2026).
   Le bloc vient de l'app Globe (points relais) : on garde son HTML (masqué) et son fonctionnement,
   on affiche à la place UNE ligne « relais d'abord » :
   - par défaut : « Choisir mon point relais — Sélectionner » (bordure bordeaux) + lien « ou livraison à domicile » ;
   - relais choisi  : nom du point · prix — Modifier ;
   - domicile : seulement si la cliente l'a choisi via notre lien pendant la visite (sinon un choix
     mémorisé par l'app est effacé et on revient au relais, pour que la caisse ne présélectionne pas le domicile) ;
   - Commander sans rien choisir : 1er clic = rappel discret (« Il ne reste qu'à choisir votre point »),
     2e clic = on laisse passer (le choix peut se faire à la caisse).
   - Point relais choisi depuis notre ligne : on enchaîne directement sur le paiement (après 1,2 s,
     le temps que l'app enregistre le point dans le panier).
   Le total du bouton Commander et le montant Klarna incluent la livraison choisie.
   Styles : snippets/ith-globe-compact.liquid. */
(function () {
  if (window.__igcBound) return;
  window.__igcBound = true;

  var PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="2.6"/></svg>';
  var HOME = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/></svg>';
  var AWAIT_MS = 10 * 60 * 1000;
  var GO_DELAY = 1200;

  function priceText(el) {
    if (!el) return '';
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (/^gratuit/i.test(t) || /^offert/i.test(t) || /^0[,.]00/.test(t)) return 'offerte';
    return t;
  }

  function toCents(t) {
    if (!t) return null;
    if (t === 'offerte') return 0;
    var m = t.replace(/\s/g, '').match(/(\d+)(?:[,.](\d{1,2}))?/);
    if (!m) return null;
    return parseInt(m[1], 10) * 100 + (m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0);
  }

  function money(c) {
    var e = Math.floor(c / 100), r = c % 100;
    return e + ',' + (r < 10 ? '0' : '') + r + ' €';
  }

  function rootOf(sel) { return sel.closest('cart-drawer') || sel.closest('.ithc') || document; }

  /* Total du bouton + Klarna = articles + livraison choisie */
  function applyTotal(sel, shipCents) {
    var root = rootOf(sel);
    var total = root.querySelector('.cart-checkout-btn__total[data-cart-total-price]');
    if (!total) return;
    var base = parseInt(total.getAttribute('data-cart-total-price'), 10) || 0;
    var ship = shipCents || 0;
    var strike = total.querySelector('.cart-checkout-btn__strike');
    if (strike) {
      if (!strike.hasAttribute('data-igc-base')) strike.setAttribute('data-igc-base', String(toCents(strike.textContent) || 0));
      strike.textContent = money((parseInt(strike.getAttribute('data-igc-base'), 10) || 0) + ship);
    }
    Array.prototype.slice.call(total.childNodes).forEach(function (n) { if (n.nodeType === 3) total.removeChild(n); });
    total.appendChild(document.createTextNode(money(base + ship)));
    var k = root.querySelector('.cart-klarna strong');
    if (k) k.textContent = money(Math.floor((base + ship) / 3));
  }

  function opt(sel, m) { return sel.querySelector('.globe-delivery-option[data-delivery-method="' + m + '"]'); }

  function isOn(o) {
    if (!o) return false;
    var inp = o.querySelector('input');
    var b = (o.style.borderColor || o.style.border || '').replace(/\s/g, '');
    return !!((inp && inp.checked) || /rgb\(0,0,0\)|#000(000)?\b|rgb\(17,17,17\)/i.test(b));
  }

  function pickupPrice(sel) {
    var o = opt(sel, 'pickup');
    if (!o) return '';
    var pt = '';
    o.querySelectorAll('.globe-delivery-price').forEach(function (p) { if (!pt) pt = priceText(p); });
    return pt;
  }

  function homePrice(sel) {
    var o = opt(sel, 'home');
    return o ? priceText(o.querySelector('.globe-delivery-price')) : '';
  }

  function pointName(sel) {
    var o = opt(sel, 'pickup');
    if (!o) return '';
    var box = o.querySelector('[id^="globe-pickup-selected"]');
    if (!box || box.style.display === 'none') return '';
    var n = o.querySelector('[id^="globe-point-name"]');
    var t = n ? n.textContent.trim() : '';
    return t && t !== '-' ? t : '';
  }

  function priceHtml(pt) {
    if (pt === 'offerte') return '<b>offerte</b>';
    return pt ? '<b>' + pt + '</b>' : '';
  }

  /* Le domicile ne s'affiche que s'il a été choisi via notre lien pendant la visite. */
  function homeChosen() {
    try { return sessionStorage.getItem('igcHomeChosen') === '1'; } catch (e) { return false; }
  }
  function setHomeChosen(on) {
    try { if (on) sessionStorage.setItem('igcHomeChosen', '1'); else sessionStorage.removeItem('igcHomeChosen'); } catch (e) {}
  }
  /* Efface un choix « domicile » mémorisé par l'app (visite précédente…) : retour au relais,
     et la caisse ne présélectionne plus le domicile. Une seule fois par page. */
  function resetHome(sel) {
    if (window.__igcResetDone) return;
    window.__igcResetDone = true;
    var o = opt(sel, 'home');
    var inp = o && o.querySelector('input');
    if (inp) inp.checked = false;
    try { sessionStorage.removeItem('globeCartDeliveryState'); } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { globe_DeliveryMethod: '' } })
    }).catch(function () {});
  }

  /* Point relais tout juste choisi depuis notre ligne → direction le paiement */
  function goCheckout(sel) {
    if (sel.__igcGoing) return;
    sel.__igcGoing = true;
    var root = rootOf(sel);
    var btn = root.querySelector('.cart-checkout-btn');
    setTimeout(function () {
      if (btn) btn.click();
      else window.location.href = '/checkout';
    }, GO_DELAY);
  }

  function render(sel) {
    var box = sel.querySelector('.igc__box');
    if (!box) return;
    var homeRaw = isOn(opt(sel, 'home'));
    var home = homeRaw && homeChosen();
    var pickup = isOn(opt(sel, 'pickup'));
    var pName = pointName(sel);
    if (homeRaw && !home && !(pickup && pName)) resetHome(sel);
    var pPrice = pickupPrice(sel), hPrice = homePrice(sel);
    var line = box.querySelector('.igc__line');
    var alt = box.querySelector('.igc__alt');
    var state, ship = null;
    var justPicked = false;

    if (pickup && pName) {
      state = 'pickup';
      ship = toCents(pPrice);
      justPicked = !!(sel.__igcAwait && Date.now() - sel.__igcAwait < AWAIT_MS && pName !== sel.__igcPrevPoint);
      var sub = justPicked
        ? 'Point choisi · direction le paiement…'
        : 'Point relais' + (pPrice ? ' · ' + priceHtml(pPrice) : '');
      line.innerHTML = '<span class="igc__ico">' + PIN + '</span><span class="igc__txt"><span class="igc__main">' + pName + '</span>'
        + '<span class="igc__sub">' + sub + '</span></span>' + (justPicked ? '' : '<span class="igc__act">Modifier</span>');
      line.setAttribute('aria-label', 'Point relais choisi : ' + pName + '. Modifier');
      alt.innerHTML = 'ou livraison à domicile' + (hPrice ? ' · ' + (hPrice === 'offerte' ? 'offerte' : hPrice) : '');
      alt.setAttribute('data-go', 'home');
    } else if (home) {
      state = 'home';
      ship = toCents(hPrice);
      line.innerHTML = '<span class="igc__ico">' + HOME + '</span><span class="igc__txt"><span class="igc__main">Livraison à domicile</span>'
        + '<span class="igc__sub">' + (hPrice ? priceHtml(hPrice) : '') + '</span></span><span class="igc__act">Modifier</span>';
      line.setAttribute('aria-label', 'Livraison à domicile choisie. Choisir un point relais à la place');
      alt.innerHTML = 'ou point relais' + (pPrice ? ' · ' + (pPrice === 'offerte' ? 'offert' : pPrice + ' · offert dès 50 €') : '');
      alt.setAttribute('data-go', 'pickup');
    } else {
      state = 'invite';
      var sub2 = sel.classList.contains('is-remind')
        ? 'Il ne reste qu’à choisir votre point'
        : (pPrice === 'offerte' ? 'Offert' : (pPrice ? pPrice + ' · offert dès 50 €' : 'Offert dès 50 €'));
      line.innerHTML = '<span class="igc__ico">' + PIN + '</span><span class="igc__txt"><span class="igc__main">Choisir mon point relais</span>'
        + '<span class="igc__sub">' + sub2 + '</span></span><span class="igc__act" style="color:#6E1C24">Sélectionner</span>';
      line.setAttribute('aria-label', 'Choisir mon point relais');
      alt.innerHTML = 'ou livraison à domicile' + (hPrice ? ' · ' + (hPrice === 'offerte' ? 'offerte' : hPrice) : '');
      alt.setAttribute('data-go', 'home');
    }
    sel.classList.toggle('is-invite', state === 'invite');
    if (state !== 'invite') sel.classList.remove('is-remind');
    sel.setAttribute('data-igc-state', state);
    applyTotal(sel, ship);
    if (justPicked) { sel.__igcAwait = 0; goCheckout(sel); }
  }

  function enhance(sel) {
    if (!sel.hasAttribute('data-igc')) {
      sel.setAttribute('data-igc', '1');
      sel.classList.add('igc');
      var box = document.createElement('div');
      box.className = 'igc__box';
      box.innerHTML = '<button type="button" class="igc__line"></button><button type="button" class="igc__alt"></button>';
      sel.insertBefore(box, sel.firstChild);
      new MutationObserver(function () {
        if (sel.__igcTimer) return;
        sel.__igcTimer = setTimeout(function () { sel.__igcTimer = null; render(sel); }, 60);
      }).observe(sel, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'checked'] });
    }
    render(sel);
  }

  function openPickup(sel) {
    sel.__igcAwait = Date.now();
    sel.__igcPrevPoint = pointName(sel);
    if (window.globeCartPickupSelector && typeof window.globeCartPickupSelector.open === 'function') {
      window.globeCartPickupSelector.open();
    } else {
      var o = opt(sel, 'pickup');
      if (o) o.click();
    }
  }

  function chooseHome(sel) {
    sel.__igcAwait = 0;
    setHomeChosen(true);
    var o = opt(sel, 'home');
    if (!o) return;
    var inp = o.querySelector('input');
    o.click();
    if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    setTimeout(function () { render(sel); }, 150);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var line = t.closest && t.closest('.igc__line');
    if (line) {
      e.preventDefault();
      openPickup(line.closest('.igc'));
      return;
    }
    var alt = t.closest && t.closest('.igc__alt');
    if (alt) {
      e.preventDefault();
      var s2 = alt.closest('.igc');
      if (alt.getAttribute('data-go') === 'home') chooseHome(s2); else openPickup(s2);
      return;
    }
    /* Commander sans mode de livraison : un rappel, une seule fois */
    var btn = t.closest && t.closest('.cart-checkout-btn');
    if (btn && e.isTrusted) {
      var root = btn.closest('cart-drawer') || btn.closest('.ithc');
      var s3 = root && root.querySelector('.igc');
      if (s3 && s3.getAttribute('data-igc-state') === 'invite' && !s3.hasAttribute('data-igc-reminded')) {
        e.preventDefault();
        e.stopPropagation();
        s3.setAttribute('data-igc-reminded', '1');
        s3.classList.add('is-remind');
        render(s3);
        s3.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var l = s3.querySelector('.igc__line');
        if (l) l.focus({ preventScroll: true });
      }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.igc');
    if (s) setTimeout(function () { render(s); }, 50);
  });

  /* Page panier : on range le bloc Globe dans la carte récapitulatif, sous son titre */
  function placeInCard() {
    document.querySelectorAll('.ithc .globe-delivery-selector-container').forEach(function (c) {
      var card = c.closest('.ithc') && c.closest('.ithc').querySelector('.ithc__card');
      if (!card || card.contains(c)) return;
      var title = card.querySelector('.ithc__card-title');
      if (title && title.nextSibling) card.insertBefore(c, title.nextSibling); else card.appendChild(c);
    });
  }

  function scan() {
    placeInCard();
    document.querySelectorAll('cart-drawer .globe-delivery-method-selector, .ithc .globe-delivery-method-selector').forEach(enhance);
  }
  function watch() {
    scan();
    new MutationObserver(function () {
      if (window.__igcScan) return;
      window.__igcScan = setTimeout(function () { window.__igcScan = null; scan(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
